export default __webpack_public_path__ + "static/media/image1.12191eb0.jpg";